export const actions = {
  /* Auth */
  STORE_ANONYMOUS_TOKEN: 'STORE_ANONYMOUS_TOKEN',
  UPDATE_ACCESS_TOKEN: 'UPDATE_ACCESS_TOKEN',
  TOUCH_SESSION: 'TOUCH_SESSION',
  USER_LOGIN : 'USER_LOGIN',
  USER_LOGIN_ASYNC : 'USER_LOGIN_ASYNC',
  STORE_PROFILE_INFO: 'STORE_PROFILE_INFO',
  STORE_RESOURCE_DOWNLOAD: 'STORE_RESOURCE_DOWNLOAD',
  STORE_TEACHER_SUBSCRIPTIONS: 'STORE_TEACHER_SUBSCRIPTIONS',
  STORE_TEACHER_IMPLEMENTATIONS: 'STORE_TEACHER_IMPLEMENTATIONS',
  SET_TEACHER_IMPLEMENTATIONS_FETCHED_AT: 'SET_TEACHER_IMPLEMENTATIONS_FETCHED_AT',
  SET_TEACHER_IMPLEMENTATIONS_LOADING: 'SET_TEACHER_IMPLEMENTATIONS_LOADING',
  STORE_SUBSCRIPTION_SCHOOLS: 'STORE_SUBSCRIPTION_SCHOOLS',
  STORE_SUBSCRIPTION_SCHOOL_LIMITS: 'STORE_SUBSCRIPTION_SCHOOL_LIMITS',
  STORE_SCHOOL_LEVELS: 'STORE_SCHOOL_LEVELS',
  UPDATE_PROFILE_INFO: 'UPDATE_PROFILE_INFO',
  UPDATE_PROFILE_EMAIL_INFO: 'UPDATE_PROFILE_EMAIL_INFO',
  GET_ADMIN_ROLES: 'GET_ADMIN_ROLES',
  STORE_ADMIN_ROLES: 'STORE_ADMIN_ROLES',
  LOG_OUT : 'LOG_OUT',
  BECOME_USER: 'BECOME_USER',
  SET_BECOME_USER: 'SET_BECOME_USER',
  UNBECOME_USER: 'UNBECOME_USER',

  /* SSO */
  GOOGLE_SSO_LOGIN: 'GOOGLE_SSO_LOGIN',
  CLASSLINK_SSO_LOGIN: 'CLASSLINK_SSO_LOGIN',
  MICROSOFT_SSO_LOGIN: 'MICROSOFT_SSO_LOGIN',
  ISAFE_DIRECT_SSO_LOGIN: 'ISAFE_DIRECT_SSO_LOGIN',
  ISAFE_DIRECT_SSO_START: 'ISAFE_DIRECT_SSO_START',
  ISAFE_DIRECT_SSO_SUCCESS: 'ISAFE_DIRECT_SSO_SUCCESS',
  ISAFE_DIRECT_SSO_FAILURE: 'ISAFE_DIRECT_SSO_FAILURE',
  ISAFE_DIRECT_SSO_CLEAR: 'ISAFE_DIRECT_SSO_CLEAR',
  SET_SSO_FLAG: 'SET_SSO_FLAG',

    /* Subscription Detail */
  PUT_SUBSCRIPTION_DETAIL : 'PUT_SUBSCRIPTION_DETAIL',
  GET_SUBSCRIPTION_DETAIL_ASYNC : 'GET_SUBSCRIPTION_DETAIL_ASYNC',
  STORE_SELECTED_SUBSCRIPTION: 'STORE_SELECTED_SUBSCRIPTION',
  SELF_IMPLEMENTATION_ASYNC: 'SELF_IMPLEMENTATION_ASYNC',
  SELF_IMPLEMENTATION_SUCCESS: 'SELF_IMPLEMENTATION_SUCCESS',
  SELF_IMPLEMENTATION_FAILURE: 'SELF_IMPLEMENTATION_FAILURE',
  
  /* ILEARN Certification */
  STORE_MODULE_INFO: 'STORE_MODULE_INFO',
  STORE_ILEARN_USER_INFO: 'STORE_ILEARN_USER_INFO',
  GET_MODULE_CHAPTER: 'GET_MODULE_CHAPTER', 
  STORE_MODULE_CHAPTER: 'STORE_MODULE_CHAPTER',
  UPDATE_USER_ILEARN_PROGRESS_ASYNC: 'UPDATE_USER_ILEARN_PROGRESS_ASYNC',
  UPDATE_USER_ILEARN_PROGRESS: 'UPDATE_USER_ILEARN_PROGRESS',
  SELECT_MODULE: 'SELECT_MODULE',
  SELECT_MODULE_ASYNC: 'SELECT_MODULE_SYNC',
  /* Become Functionality */
  SET_BECOME: 'SET_BECOME',
  SET_BECOME_ORIGIN: 'SET_BECOME_ORIGIN',
  SET_SELF_IMPLEMENTED: 'SET_SELF_IMPLEMENTED',

  /* ISAFE AI */
  SET_AGE_VERIFICATION: 'SET_AGE_VERIFICATION',

  /* UI */
  SHOW_ERROR_MODAL: 'SHOW_ERROR_MODAL',
  HIDE_ERROR_MODAL: 'HIDE_ERROR_MODAL',
  SHOW_GLOBAL_LOADING: 'SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'HIDE_GLOBAL_LOADING',
  FETCH_RESOURCE_DOWNLOAD_ASYNC: 'FETCH_RESOURCE_DOWNLOAD_ASYNC',
  FETCH_ILEARN_CONTENT_ASYNC: 'FETCH_ILEARN_CONTENT_ASYNC',
};

export const OTP_METHODS = {
  SMS: 'sms',
  PUSH: 'push',
  EMAIL: 'email',
};
